import { useCallback, useEffect } from 'react';
import { State, useStore } from 'store';

import fetchWorkflowErrorSummary from 'store/fetchWorkflowErrorSummary';

import IAsync from 'types/IAsync';
import IWorkflowErrorSummary from 'types/IWorkflowErrorSummary';

const initAsync: IAsync<IWorkflowErrorSummary> = { status: 'INIT' };

export default function useWorkflowErrorSummaryAsync(projectId: string, wfId: string): IAsync<IWorkflowErrorSummary> {
  const async = useStore(useCallback((state: State) => state.dashboard.errorSummaryAsyncMap[wfId], [wfId]));

  useEffect(() => {
    fetchWorkflowErrorSummary(projectId, wfId);
  }, [projectId, wfId]);

  return async ?? initAsync;
}
